import React from 'react';
import "./styles/main.scss";
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeContextProvider } from './contexts/ThemeContext';
import {BrowserRouter} from 'react-router-dom';
import { SocketProvider } from './contexts/SocketContext';
import ToastContextProvider from './contexts/ToastContext';

import "./assets/preload";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastContextProvider>
        <SocketProvider>
          <ThemeContextProvider>
            <App />
          </ThemeContextProvider>
        </SocketProvider>
      </ToastContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if ("serviceWorker" in window.navigator) {
  window.addEventListener("load", () => {
    window.navigator.serviceWorker.register("/sw.js");
  });
}
